






































import { Component, Mixins } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'

// Mixins
import Form from '@/mixins/Form'
import Errors from '@/mixins/Errors'

@Component
export default class EditInformationProfile extends Mixins(Form, Errors) {
  firstName: string = null
  lastName: string = null
  company: string = null
  formLoading: boolean = false
  displayErrors: any

  @Getter('profile', { namespace: 'user' }) user
  @Getter('master', { namespace: 'user' }) isMaster
  @Action('updateInformations', { namespace: 'user' }) updateInformations

  created() {
    this.firstName = this.user.firstName || ''
    this.lastName = this.user.lastName || ''
    this.company = this.user.company || ''
  }

  async submitForm() {
    try {
      const res = await this.$validator.validateAll()
      this.formLoading = true
      await this.updateInformations({ firstName: this.firstName, lastName: this.lastName, company: this.company })
      this.$toast.open({
        message: this.$t('profile.edit_information.notification.success.title') as string,
        duration: 5000,
        type: 'is-success'
      })
    } catch (error) {
      this.displayErrors(error)
    } finally {
      this.formLoading = false
    }
  }
}
